import type { Dict } from "./types";

/** Rusa.
 *
 *  Aceleași două reguli ca la română: numele de tehnologii rămân neatinse, iar
 *  tonul rămâne direct și concret. În rusă tentația e mai mare să alunece în
 *  registrul oficial-birocratic („осуществляем комплексную разработку") — evitat
 *  peste tot, fiindcă site-ul vorbește la persoana întâi și spune lucruri
 *  verificabile.
 *
 *  Cifrele urmează convenția locală: virgula ca separator zecimal, spațiu la mii. */
export const ru: Dict = {
  tag: "ru",

  nav: { index: "Главная", services: "Услуги", work: "Работы", blog: "Блог", faq: "Ответы", contact: "Контакты", menu: "Меню", closeMenu: "Закрыть меню" },

  workPage: {
    eyebrow: "Работы",
    title: "Семь проектов, шесть из них в продакшене",
    intro: "Каждый проект здесь сдан или работает сегодня, и у каждого своя страница: задача, подход и что он реально изменил. Один — открытый эксперимент, и так и написано.",
    open: "Открыть кейс",
    task: "Задача",
    solution: "Решение",
    result: "Результат",
  },

  servicesPage: { eyebrow: "Услуги", title: "Семь вещей, которые мы делаем, и что входит в каждую", intro: "Без пакетов и уровней. Каждая из них — реальная работа со своими рисками, а список ниже — то, что в неё действительно входит, а не меню, написанное чтобы выглядеть полным." },

  faqPage: { eyebrow: "Ответы", title: "Сколько стоит проект, сколько занимает и что остаётся вашим", intro: "Вопросы, от которых зависит, напишете вы нам или нет — с ответами и на те части, которые коммерческое предложение обычно прячет. Если вашего здесь нет, задайте его в форме: ответим в любом случае." },

  contactPage: {
    eyebrow: "Контакты",
    title: "Расскажите, что нужно изменить — ответим за 24 часа",
    intro: "Самый быстрый путь — форма ниже: два клика и то, что вы хотите рассказать о проекте. Если проще написать письмом, адрес под ней.",
    directHead: "Или напишите напрямую",
    directText: "Обычное письмо работает не хуже формы. Пропустив её, вы ничего не теряете.",
    callHead: "Или назначьте звонок",
    callText: "Если удобнее сначала поговорить — займите слот напрямую. Заполнять форму заранее не нужно: объём работ обсудим на звонке.",
    callBtn: "Назначить звонок",
    chatHead: "Или напишите",
    chatText: "WhatsApp или Telegram — что у вас уже открыто. Ответ тот же, только начнётся быстрее: их читает человек, без бота и общего ящика.",
    whereHead: "Где мы находимся",
    hours: "Понедельник–пятница, 9:00–18:00",
    nextHead: "Что происходит после отправки",
    next: [
      "Читает человек — без очереди и без автоответчика.",
      "Ответ в течение 24 часов, в том числе когда это не наша задача.",
      "Если задача наша, следующий шаг — бесплатный звонок, а не счёт.",
    ],
  },

  seeAll: { services: "Все семь услуг", faq: "Все ответы", work: "Все работы" },

  home: {
    h1: ["Софт, выкованный", "для продакшена."],
    sub: "Сайты, десктопные приложения, автоматизация. Делаем от начала до конца и потом поддерживаем в работе.",
    ctaStart: "Начать проект",
    ctaWork: "Смотреть работы",
    scale: [
      { n: "4", l: "года" },
      { n: "20", l: "проектов" },
      { n: "6", l: "стран" },
    ],
    painsHead: "Где болит?",
    workHead: "Избранные работы",
    servicesHead: "Услуги",
    stepsHead: "Как идёт работа",
    stepsEyebrow: "От первого звонка до работы в продакшене",
    faqHead: "Частые вопросы",
    faqEyebrow: "Всё, что спрашивают до первого звонка",
    briefHead: "Начать проект",
    rows: [
      {
        nm: "ERP для розницы с несколькими складами",
        st: "Три точки на одном остатке. От продажи до фискального чека одним нажатием. · Десктоп, 2025",
      },
      {
        nm: "Компьютерное зрение с AI на устройстве",
        st: "30 fps на самом устройстве, без похода в облако. · Embedded, 2026",
      },
      {
        nm: "Двуязычный интернет-магазин",
        st: "1 500 посетителей в день, два языка, оплата картой работает. · Веб, 2025",
      },
      {
        nm: "Исследовательский торговый бот на AI",
        st: "~+1,5% медианный дневной P&L — на бумаге, пока эксперимент. · Автоматизация, 2026",
      },
    ],
    services: [
      {
        id: "cap-web",
        title: ["Веб и", "интернет-магазины"],
        p: "Магазины, порталы, дашборды и платформы бронирования — вместе с платёжной и фискальной обвязкой за ними.",
        items: ["Магазины и каталоги", "Порталы и дашборды", "Оплата картой и фискальные чеки", "Многоязычность с отдельной индексацией"],
        kind: "Web app",
      },
      {
        title: ["Мобильные", "приложения"],
        p: "Нативные iOS и Android там, где важно железо, кроссплатформа там, где важен охват, — и честный ответ, что именно нужно вам.",
        items: ["Нативные iOS и Android", "Кроссплатформенно из одного кода", "Данные сначала офлайн", "Push-уведомления и deep links"],
        kind: "Mobile app",
      },
      {
        id: "cap-desktop",
        title: ["Десктоп и", "embedded"],
        p: "Софт для торгового зала и цеха: работает, когда сеть не работает, общается с устройствами и запускается на железе, которое мы можем спроектировать, если его ещё нет.",
        items: ["Десктоп под любую систему", "Offline с самого начала, синхронизация при возврате сети", "Устройства по serial, USB и фискальные", "Своя плата, когда готовой нет"],
        kind: "Desktop",
      },
      {
        id: "cap-auto",
        title: ["Автоматизация и", "интеграции"],
        p: "Системы, за которые вы уже платите, заставлены разговаривать друг с другом — чтобы никто не перебивал данные во второй экран.",
        items: ["Интеграция ERP, CRM и баз данных", "Чужие API и webhooks", "Уведомления в Telegram и почту", "Задачи по расписанию и потоки данных"],
        kind: "Automation",
      },
      {
        title: ["AI, который", "доходит до продакшена"],
        p: "Модели там, где они себя окупают, с обычным детерминированным кодом, который держит границы вокруг них.",
        items: ["Детекция и OCR на устройстве", "Функции на LLM с проверкой человеком", "Сгенерированный текст, вычитанный до публикации", "Детерминированные ограничения вокруг модели"],
        kind: "Automation",
      },
      {
        title: ["Данные и", "дашборды"],
        p: "Цифры, которые говорят, работает ли всё это, — в одном месте, а не в пяти выгрузках, которые никто не сводит.",
        items: ["Модель данных и проектирование схемы", "Дашборды отчётности", "Аналитика без агрессивной слежки", "Переезд из таблиц Excel"],
        kind: "Automation",
      },
      {
        title: ["Технический", "аудит"],
        p: "Разбор того, что у вас уже есть, до решения — чинить или заменять. Выводы вы получаете независимо от того, наймёте нас или нет.",
        items: ["Производительность и Core Web Vitals", "Технический SEO и индексируемость", "Архитектура и чтение кода", "Проверка зависимостей и безопасности"],
        kind: "Not sure yet",
      },
    ],
    steps: [
      {
        n: "01",
        h: "Первый звонок",
        p: "Бесплатный звонок, где мы слушаем задачу и говорим, подходим ли мы для неё. Без презентации и без счёта за «дискавери». Если это не наше, вы узнаете об этом сейчас, а не через три недели.",
      },
      {
        n: "02",
        h: "Периметр",
        p: "Сценарии, модель данных, критерии успеха. Договариваемся, что значит «готово», ещё до того как что-то пишется, и цена фиксируется под это — или ретейнер, если у работы нет чёткого конца.",
      },
      {
        n: "03",
        h: "Дизайн",
        p: "Токены и компоненты один раз, дальше переиспользуются. Без шаблонов и пакетов: ваш продукт не выйдет похожим на предыдущий, который мы сдали.",
      },
      {
        n: "04",
        h: "Разработка",
        p: "Фронтенд, бэкенд, слой данных, интеграции. Прогресс видите каждую неделю и утверждаете каждый этап до начала следующего — так в конце ничего не окажется неожиданностью.",
      },
      {
        n: "05",
        h: "Эксплуатация",
        p: "CI/CD, мониторинг, runbook. Мы не исчезаем на запуске — но и вы не привязаны к нам: код, документация и runbook ваши, и запускать их можно без нас.",
      },
    ],
  },

  pains: {
    items: [
      "Мне нужен сайт, который приносит заказы, а не комплименты",
      "Моя команда весь день перебивает одни и те же данные",
      "Мои программы не разговаривают друг с другом",
      "В торговом зале нужна программа, которая работает без интернета",
      "У меня есть железо, и нечего на нём запускать",
      "Я знаю, где болит, но не знаю, что строить",
    ],
    outHead: "Нет в списке?",
    outText: "Опишите своими словами. Отвечаем в любом случае — в том числе когда это не наша задача.",
    outBtn: "Описать задачу",
    defects: [
      { n: "Пористость", leg: "Снаружи целый, внутри пустой. Выглядит законченным и ничего не держит." },
      { n: "Канавка износа", leg: "Один и тот же проход, каждый день, режет паз, который никто не заложил в смету." },
      { n: "Непровар", leg: "Два потока встретились и не сварились. Шов держит до первой нагрузки." },
      { n: "Зона термического влияния", leg: "Рядом с процессом металл — уже не тот металл из каталога." },
      { n: "Незаполненная полость", leg: "Полость обработана. В неё так ничего и не потекло." },
      { n: "Размер без значения", leg: "Замер выставлен. Число — это как раз то, что мы ищем." },
    ],
  },

  brief: {
    steps: [
      { q: "Что строим?", opts: ["Веб-приложение", "Мобильное приложение", "Десктоп", "Автоматизацию", "Пока не знаю"] },
      { q: "Когда начинаем?", opts: ["Как можно скорее", "1–3 месяца", "Гибко"] },
    ],
    detailsQ: "Расскажите о проекте",
    detailsPlaceholder: "Что он должен делать, что уже есть и с чем должен разговаривать. Можно коротко — остальное спрошу на звонке.",
    detailsOptional: "Не обязательно, но чем больше напишете, тем полезнее будет мой первый ответ.",
    mailQ: "Куда отправить предложение?",
    mailPlaceholder: "ваш@email.com",
    send: "Отправить заявку",
    sending: "Отправляю…",
    sendByEmail: "Отправить письмом",
    botFailed:
      "Проверка на бота не запускается в этом браузере, поэтому форма не может отправиться. Кнопка выше откроет письмо с уже заполненными ответами.",
    badEmail: "Адрес выглядит неправильно.",
    generic: "Что-то не сработало.",
    doneText: "Отвечу в течение 24 часов.",
    another: "Отправить ещё одну",
    block: "Основная надпись",
  },

  serviceBack: "← Все услуги",
  stackNote: "Ссылка рядом с группой означает, что она работает в продакшене в проекте, который можно прочитать. Остальное — то, что команда также покрывает.",
  stackProof: "В продакшене:",
  stackAlso: "Также покрываем",
  serviceOther: "Другие услуги",
  serviceMore: "Подробнее об услуге",
  servicePages: [
    {
      slug: "web", num: "01", eyebrow: "Веб и e-commerce", kind: "Web app",
      title: "Магазины, порталы и платёжная обвязка за ними",
      intro:
        "Веб-проект редко бывает просто набором страниц. Это каталог, который должен оставаться корректным, платёж, который должен пройти через конкретный банк, чек, который должен устроить налоговую, и второй язык, который должен быть полным, а не переведённым наполовину. Мы делаем всё это, а не ту часть, которая хорошо смотрится на скриншоте.",
      includedHead: "Что входит",
      included: [
        { h: "Магазины и каталоги", p: "Товары как данные, а не как страницы. Новая позиция — это строка в базе, поэтому каталог не гниёт по мере роста, а поиск и фильтры работают и на тысяче товаров." },
        { h: "Порталы и панели", p: "Экраны, в которых ваши люди сидят весь день. Сделаны под скорость ввода, а не под скриншот: сначала клавиатура, без окна, которое закрывает строку, что вы читали." },
        { h: "Оплата картой и фискальные чеки", p: "Локальные платёжные рельсы, а не только Stripe. Мы делали оплату через MAIB с фискальной накладной при завершении заказа — та часть, которую большинство проектов обнаруживает слишком поздно." },
        { h: "Многоязычность, индексируемая по языкам", p: "У каждого языка свой адрес и своя мета, поэтому обе версии ранжируются отдельно. Контент живёт по локали на уровне поля, поэтому страница может быть готова на одном языке и в работе на другом, ничего не ломая." },
        { h: "Пререндер для краулеров", p: "Каждый маршрут рендерится в статический HTML на сборке, поэтому поисковик или соцсеть получают полную страницу, а не пустую оболочку, которая наполняется после JavaScript." },
      ],
      buildsHead: "Что мы делаем",
      builds: [
        { h: "Интернет-магазины и каталоги", p: "Остатки, варианты, заказы и оформление, которое проходит через банк, которым ваши клиенты действительно пользуются, с чеком, который ждёт налоговая." },
        { h: "Платформы бронирования", p: "Доступность, правила цен, подтверждения и календарь диспетчера — с уведомлением, которое приходит на телефон, а не в почту, куда никто не заходит." },
        { h: "Клиентские порталы и внутренние панели", p: "Экраны, в которых сотрудники работают весь день: заказы, документы, статусы, роли и кто что имеет право менять." },
        { h: "Маркетплейсы с несколькими продавцами", p: "Кабинеты продавцов, комиссии, выплаты и модерация — то, что превращает каталог в площадку, где могут продавать другие." },
        { h: "Корпоративные сайты на нескольких языках", p: "Каждый язык — настоящая версия со своим адресом и метой, а не плагин, переводящий поверх одной." },
        { h: "CMS и headless-публикация", p: "WordPress или headless CMS за быстрым фронтендом, чтобы маркетинг публиковал, не дожидаясь разработчика." },
      ],
      stackHead: "Стек",
      stack: [
        { h: "Фронтенд", items: ["React", "TypeScript", "Vite", "Tailwind", "shadcn/ui", "i18next", "react-hook-form", "Sass"], proof: "createli", also: ["Next.js", "Vue", "Nuxt", "Astro"] },
        { h: "CMS и PHP", items: ["WordPress", "WooCommerce", "PHP", "Laravel"] },
        { h: "Бэкенд и данные", items: ["Node.js", "Express", "PostgreSQL", "MySQL", "Sequelize", "REST API"], proof: "commerce", also: ["Python", "FastAPI", "Django", ".NET", "Java", "Spring", "MongoDB", "Redis", "ClickHouse"] },
        { h: "Платежи и фискальные чеки", items: ["MAIB", "фискальные накладные"], proof: "commerce", also: ["MICB", "PayNet", "Stripe", "PayPal"] },
        { h: "Хостинг и индексация", items: ["nginx", "PM2", "пререндер Puppeteer", "JSON-LD", "sitemap", "hreflang"], proof: "elegance", also: ["AWS", "Google Cloud", "Azure", "Docker", "Kubernetes", "Vercel", "Netlify", "Fly.io"] },
      ],
      fitsHead: "Кому подходит",
      fits: [
        { h: "Магазинам, которые продают на нескольких языках", p: "Если ваши клиенты читают на разных языках, плагин перевода стоит вам каждого рынка, которого он касается. Полная версия на каждом языке дешевле одной сломанной, растянутой на все." },
        { h: "Бизнесу с локальной платёжной задачей", p: "Оплата через региональный банк, фискальные чеки, правила выставления счетов, которых не реализует ни одна международная платформа. Здесь это обычная работа, в другом месте — экзотика." },
        { h: "Всем, чей сайт невидим для поиска", p: "Если ваши страницы — JavaScript-приложение, краулер может не получать вообще ничего. Это проверяется за минуту и чинится за день." },
      ],
    },
    {
      slug: "mobile", num: "02", eyebrow: "Мобильные приложения", kind: "Mobile app",
      title: "Приложения для телефона вашего клиента и вашего водителя",
      intro:
        "Приложение оправдывает свою цену тогда, когда телефон делает то, чего не может вкладка браузера: работает без связи, читает штрихкод, держит сессию водителя весь день или присылает уведомление, которое действительно доходит. Мы делаем нативно там, где важно железо, и кроссплатформенно там, где важен охват, — и говорим, какой случай ваш, до того как вы заплатите за любой из них.",
      includedHead: "Что входит",
      included: [
        { h: "Нативные iOS и Android", p: "Swift на iOS, Kotlin на Android. Верный путь, когда приложение опирается на устройство: камера, фоновая геолокация, Bluetooth, защищённое хранилище или скорость, которой обёртка не даст." },
        { h: "Кроссплатформенно из одного кода", p: "React Native или Flutter, когда приложение — это в основном экраны и данные. Оба магазина из одного кода вдвое удешевляют каждое изменение после запуска." },
        { h: "Данные сначала офлайн", p: "Приложение держит свои данные локально и сверяет их при возврате сети. Курьер в подвале и склад без покрытия — обычный случай, а не исключение." },
        { h: "Push-уведомления и deep links", p: "Уведомление открывает нужный экран, а не главный, — включая неблагодарную половину: токены, тихие сбои доставки и то, что происходит после переустановки." },
        { h: "Публикация в магазинах и обновления", p: "Правила ревью, декларации о приватности, подписи и канал обновлений после. Публикуется под вашим аккаунтом разработчика, а не под нашим, чтобы приложение осталось вашим." },
      ],
      buildsHead: "Что мы делаем",
      builds: [
        { h: "Приложения к системе, которая у вас уже есть", p: "Телефонная половина магазина, ERP или платформы бронирования, работающая с той же базой, что и веб-приложение." },
        { h: "Приложения для выездных и курьеров", p: "Маршруты, сканы, подписи и фотографии снимаются офлайн и уходят на сервер, когда возвращается сигнал." },
        { h: "Приложения заказа и бронирования", p: "Каталог, корзина, оплата и статус заказа, с уведомлениями, которые следуют за заказом, а не за почтовым ящиком." },
        { h: "Лояльность и личные кабинеты", p: "Карты, баллы, история и предложения — причина, по которой приложение остаётся установленным через месяц после первого заказа." },
        { h: "Приложения, работающие с железом", p: "Bluetooth-весы, принтеры, сканеры и терминалы. Категория, где нативность — требование, а не предпочтение." },
        { h: "Устанавливаемые веб-приложения", p: "Когда листинг в магазине добавляет расходы, но не добавляет охвата: ставится прямо из браузера, без очереди ревью и без тридцати процентов." },
      ],
      stackHead: "Стек",
      stack: [
        { h: "Нативно", items: ["Swift", "SwiftUI", "Kotlin", "Jetpack Compose", "Xcode", "Android Studio"] },
        { h: "Кроссплатформенно", items: ["React Native", "Expo", "Flutter", "Dart", "TypeScript"] },
        { h: "Устанавливаемый веб", items: ["React", "service workers", "Web Push", "офлайн-кеш", "Web App Manifest"] },
        { h: "Бэкенд, с которым говорит приложение", items: ["Node.js", "Express", "PostgreSQL", "MySQL", "REST API", "сессии на токенах"], proof: "commerce", also: ["Python", "FastAPI", "Django", "Redis", "WebSocket"] },
      ],
      fitsHead: "Кому подходит",
      fits: [
        { h: "Бизнесу, чьи клиенты уже в телефоне", p: "Если большая часть трафика мобильная, а оформление заказа — то место, где люди уходят, приложение стоит посчитать раньше, чем ещё один редизайн." },
        { h: "Командам, работающим не за столом", p: "Курьеры, техники, водители, инспекторы. Люди с телефоном в одной руке, которым нужны три касания, а не форма." },
        { h: "Всем, кому сказали, что нужны обе платформы", p: "Иногда действительно нужны. Часто одна платформа плюс устанавливаемое веб-приложение покрывают ту же аудиторию вдвое дешевле, и это стоит часа арифметики." },
      ],
    },
    {
      slug: "desktop", num: "03", eyebrow: "Десктоп и embedded", kind: "Desktop",
      title: "Софт для торгового зала и железо под ним",
      intro:
        "Часть работы не помещается во вкладку браузера. Касса, которая должна продавать дальше, когда упал интернет, станок, который говорит по последовательному порту, плата, которой ещё не существует. Мы пишем такой софт, а когда ни одна плата не подходит — рисуем плату.",
      includedHead: "Что входит",
      included: [
        { h: "Десктопные приложения на трёх системах", p: "Один код на Windows, macOS и Linux, устанавливается и обновляется как настоящее приложение, а не как веб-страница, которая им притворяется." },
        { h: "Сначала офлайн, синхронизация при возврате", p: "Приложение держит данные локально и сверяет их, когда сеть возвращается. Магазин не перестаёт продавать оттого, что моргнул канал." },
        { h: "Serial, USB и фискальные устройства", p: "Фискальные регистраторы, сканеры, весы, принтеры. Мы управляли фискальным регистратором TREMOL S из Electron-приложения, то есть работа с протоколом сделана, а не теоретическая." },
        { h: "Своя плата, когда ничего не подходит", p: "Схема и разводка в KiCad, затем прошивка и пайплайн зрения или управления, который на ней работает. Одна команда на весь стек означает, что железо и софт спроектированы друг под друга." },
      ],
      buildsHead: "Что мы делаем",
      builds: [
        { h: "Касса и бэк-офис", p: "Продажи, остатки, смены и фискальные чеки на одной машине, которая продолжает работать, даже если канал упал посреди операции." },
        { h: "Терминалы склада и производства", p: "Сканирование, взвешивание, маркировка и перемещение остатков на железе, которое должно выжить на складе, а не на столе." },
        { h: "Управление станками и устройствами", p: "Serial, USB, Modbus и протоколы производителей — за экраном, которым оператор пользуется без инструкции." },
        { h: "Устройства с AI на борту", p: "Детекция, OCR или классификация прямо на плате: без похода в дата-центр, без цены за вызов и без простоя, когда падает линия." },
        { h: "Свои платы, от схемы до серии", p: "Схема и разводка, прототип, прошивка, затем серия — для случаев, когда готовая плата не той формы и не той цены." },
        { h: "IoT и сети датчиков", p: "Микроконтроллеры читают датчики и отчитываются, а серверная часть и дашборд придают этим показаниям смысл." },
      ],
      stackHead: "Стек",
      stack: [
        { h: "Десктоп", items: ["Electron", "React", "TypeScript", "Zustand", "TanStack Query", "MUI", "Express", "Sequelize", "PostgreSQL"], proof: "erp", also: ["Tauri", "Qt", "C#", ".NET", "WPF", "Python"] },
        { h: "Устройства и протоколы", items: ["serialport", "USB HID", "фискальный регистратор TREMOL S", "сканеры штрихкодов", "весы", "чековые принтеры"], proof: "erp", also: ["Modbus", "RS-485", "CAN", "MQTT"] },
        { h: "Embedded и edge", items: ["C++17", "RK3576", "RKNN", "GStreamer", "systemd", "LPDDR4X"], proof: "vision", also: ["ESP32", "STM32", "Raspberry Pi", "NVIDIA Jetson", "FreeRTOS", "Zephyr", "Yocto", "Buildroot"] },
        { h: "Проектирование железа", items: ["KiCad", "схемотехника", "разводка PCB"], proof: "vision", also: ["опытные партии", "сборка", "корпус"] },
      ],
      fitsHead: "Кому подходит",
      fits: [
        { h: "Рознице и общепиту", p: "Касса, остатки, фискальная отчётность. Категория, где сбой в рабочие часы — не неудобство, а потерянная выручка." },
        { h: "Производству и логистике", p: "Всему, что читает устройство, датчик или весы и должно записать это правильно с первого раза, потому что никто не станет вводить заново." },
        { h: "Продуктам, которым нужно своё железо", p: "Когда готовая плата не той формы, не той цены или без нужного интерфейса, нарисовать свою часто дешевле, чем вечно её обходить." },
      ],
    },
    {
      slug: "automation", num: "04", eyebrow: "Автоматизация и интеграции", kind: "Automation",
      title: "Системы, за которые вы уже платите, начинают говорить друг с другом",
      intro:
        "Большинству компаний не нужен ещё один инструмент. Нужно, чтобы четыре имеющихся перестали быть островами — чтобы никто не перенабирал заказ из одного экрана в другой и не сверял две таблицы, которые должны были быть одной.",
      includedHead: "Что входит",
      included: [
        { h: "Интеграция ERP, CRM и баз данных", p: "Один источник истины, остальные читают из него. Обычно это значит решить, какая система выигрывает по каждому полю, — а это решение бизнеса раньше, чем техническое." },
        { h: "Внешние API и вебхуки", p: "Платёжные провайдеры, курьеры, маркетплейсы, бухгалтерия. Включая неблагодарные части: повторы, идемпотентность и то, что происходит, когда другая сторона лежит." },
        { h: "Уведомления в Telegram и на почту", p: "Событие доходит до человека там, где он уже работает. Диспетчеру, который живёт в Telegram, не нужно открывать панель, чтобы узнать о заявке." },
        { h: "Задачи по расписанию и потоки данных", p: "Импорты, экспорты, сверки и отчёты, которые идут сами и сообщают, когда падают, — вместо того чтобы падать молча, пока кто-нибудь не заметит неверную цифру." },
      ],
      buildsHead: "Что мы делаем",
      builds: [
        { h: "Интеграции между системами", p: "Магазин в ERP, ERP в бухгалтерию, CRM на склад: один источник истины, остальные читают из него." },
        { h: "Боты, которые делают работу", p: "Боты в Telegram, WhatsApp или Viber, которые принимают заказ, отвечают о статусе или поднимают диспетчера, подключённые к настоящей базе, а не к списку заготовленных ответов." },
        { h: "Генерация документов и отчётов", p: "Счета, накладные, договоры и месячные отчёты, собранные из данных, а не перенабранные из них." },
        { h: "Задачи по расписанию и сверки", p: "Импорты, экспорты и ночные проверки, которые идут сами и сообщают человеку о падении, вместо того чтобы падать молча целый месяц." },
        { h: "Сбор данных из источников без API", p: "Цены, остатки или объявления, считанные со страниц, когда другая сторона не даёт иного входа, — в том ритме и в тех пределах, которые задаёт источник." },
        { h: "Роботы на старых интерфейсах", p: "Когда у системы нет никакого API, скрипт водит её интерфейс так, как это делал бы человек. Последнее средство и часто единственное." },
      ],
      stackHead: "Стек",
      stack: [
        { h: "Исполнение и расписание", items: ["Node.js", "Express", "Python", "cron", "systemd timers", "фоновые воркеры"], proof: "commerce", also: ["BullMQ", "Celery", "Redis", "RabbitMQ"] },
        { h: "Каналы", items: ["Telegram Bot API", "Mailgun", "Resend", "SMTP"], proof: "elegance", also: ["WhatsApp Business API", "Viber", "SMS-шлюзы"] },
        { h: "Бизнес-системы", items: ["самописные базы", "REST и вебхук API", "обмен CSV и XML"], proof: "erp", also: ["1С", "Битрикс24", "amoCRM", "HubSpot", "Salesforce"] },
        { h: "Low-code платформы", items: ["n8n", "Make", "Zapier"] },
        { h: "Автоматизация браузера", items: ["Playwright", "Puppeteer"], proof: "elegance", also: ["сбор по расписанию", "роботы на старых интерфейсах"] },
      ],
      fitsHead: "Кому подходит",
      fits: [
        { h: "Командам, которые вводят одно дважды", p: "Самый ясный признак, что интеграция окупится: в чьих-то обязанностях есть слова «скопировать в»." },
        { h: "Бизнесу, переросшему таблицы", p: "Таблицы прекрасны, пока их не редактируют двое. Миграция обычно меньше работы, чем год обходных путей перед ней." },
        { h: "Всем, у кого нет готового коннектора", p: "Региональные системы, старые ERP, самописные базы. Готовой интеграции не существует, поэтому её пишут." },
      ],
    },
    {
      slug: "ai", num: "05", eyebrow: "AI, который доходит до продакшена", kind: "Automation",
      title: "Модели там, где они себя окупают, и границы вокруг них",
      intro:
        "AI — это компонент, а не продукт. Его стоит применять там, где иначе человек делает что-то однообразное, и стоит избегать там, где детерминированное правило дешевле и никогда не ошибается. Интересная инженерия — на границе между этими двумя.",
      includedHead: "Что входит",
      included: [
        { h: "Детекция и OCR на устройстве", p: "Инференс работает на машине, а не в дата-центре: без похода туда-обратно, без цены за вызов, и продолжает работать, когда связь не работает. Мы делали детекцию и OCR быстрее 100 мс на собственной плате." },
        { h: "Функции с LLM и проверкой человеком", p: "Модель предлагает, человек утверждает, и утверждение — часть процесса, а не политика, которую никто не соблюдает. Сгенерированный текст, который никто не читает, хуже, чем его отсутствие." },
        { h: "Контент, отредактированный до публикации", p: "Описания товаров по технической спецификации, потом отредактированные. Сотни позиций становятся посильными, а каталог не читается как написанный машиной, потому что через него всё же прошёл человек." },
        { h: "Детерминированные границы вокруг модели", p: "Обычный код держит рамки: что модель может потратить, что может изменить и что должен подтвердить человек. Модель никогда не последняя проверка перед необратимым." },
      ],
      buildsHead: "Что мы делаем",
      builds: [
        { h: "Детекция и распознавание на устройстве", p: "Подсчёт, сортировка или чтение этикеток и номеров прямо на машине, с частотой видео и без облачного счёта." },
        { h: "OCR документов и чеков", p: "Сканы и фотографии превращаются в поля, которые система умеет использовать, а неуверенные случаи уходят человеку, а не угадываются." },
        { h: "Текст, написанный по вашим данным", p: "Описания товаров, сводки и ответы, собранные по спецификации или по записи, затем отредактированные человеком до того, как их увидят снаружи." },
        { h: "Классификация и маршрутизация", p: "Тикеты, сообщения и документы автоматически попадают в нужную очередь, а спорные — к человеку." },
        { h: "Поддержка исследования и решения", p: "Модель читает те же входные данные, что и человек, и предлагает действие, а обычный код решает, что ей позволено с ним сделать." },
        { h: "Приватные модели на своём сервере", p: "Llama, Mistral или похожие на вашем сервере — когда данные не могут покидать периметр или цена за вызов не сходится." },
      ],
      stackHead: "Стек",
      stack: [
        { h: "Зрение на устройстве", items: ["YOLO", "ONNX Runtime", "RKNN", "OpenCV DNN", "PP-OCRv4", "C++17"], proof: "vision", also: ["NVIDIA Jetson", "TensorRT", "Tesseract"] },
        { h: "Коммерческие API моделей", items: ["OpenAI", "Anthropic Claude"], proof: "trading" },
        { h: "Модели на своём сервере", items: ["Llama", "Mistral", "Ollama"] },
        { h: "Вокруг модели", items: ["Python 3.12", "SQLAlchemy", "APScheduler", "риск-движок", "шаг проверки человеком"], proof: "trading" },
      ],
      fitsHead: "Кому подходит",
      fits: [
        { h: "Каталогам, слишком большим для ручной работы", p: "Сотни товаров без описаний — реальные затраты. И это тот случай, где черновик плюс правка выигрывают и у письма с нуля, и у публикации сырого вывода." },
        { h: "Продуктам, которые должны работать без сети", p: "Торговые залы, транспорт, производственные площадки. Если облако необязательно, инференс должен быть локальным, а это меняет и модель, и способ сборки." },
        { h: "Тем, кто не уверен, нужен ли здесь AI вообще", p: "Иногда честный ответ — что правило сделает это лучше и дешевле. Мы предпочтём сказать это до того, как вы вложились, а не после." },
      ],
    },
    {
      slug: "data", num: "06", eyebrow: "Данные и дашборды", kind: "Automation",
      title: "Цифры, которые говорят, работает ли это, в одном месте",
      intro:
        "Большинству компаний не хватает не данных, а одной их версии. Пять выгрузок, которые никто не сверяет, — это не отчётность, это спор, который повторяется каждый месяц.",
      includedHead: "Что входит",
      included: [
        { h: "Модель данных и схема", p: "Та часть, которая решает, будет ли каждый следующий вопрос дешёвым или дорогим. Делается один раз и внимательно — до того, как затвердеет во что-то, что никто не рискнёт менять." },
        { h: "Отчётные дашборды", p: "Те несколько цифр, от которых реально зависит решение, обновляемые сами. Не стена графиков, которую все перестают открывать на второй неделе." },
        { h: "Аналитика, сначала приватность", p: "Измерения, которые не требуют баннера о куках размером со страницу. Вы получаете нужные цифры, а посетители сохраняют приватность." },
        { h: "Уход от таблиц", p: "Перенос истории без потерь, включая особые случаи, спрятанные в цветах и комментариях, которые не унесёт ни одна выгрузка." },
      ],
      buildsHead: "Что мы делаем",
      builds: [
        { h: "Один дашборд для бизнеса", p: "Выручка, остатки, заказы и маржа в одном месте, обновляются сами — вместо пяти выгрузок, которые никто не сверяет." },
        { h: "Рабочие экраны для команды", p: "То, что склад, диспетчер или поддержка держат открытым весь день: что требует внимания сейчас, а не в прошлом месяце." },
        { h: "Отчёты, которые приходят сами", p: "Недельные или месячные цифры в почте или в чате, каждый раз в одном и том же виде, и никто их не собирает вручную." },
        { h: "Схема и модель данных", p: "Решение, которое делает каждый следующий вопрос дешёвым или дорогим, принятое один раз и осознанно, а не случайно." },
        { h: "Уход от таблиц", p: "Перенос истории без потери смысла, спрятанного в цветах, комментариях и памяти одного человека." },
        { h: "Веб-аналитика без слежки", p: "Цифры по трафику и конверсии без баннера согласия размером со страницу и без передачи посетителей рекламной сети." },
      ],
      stackHead: "Стек",
      stack: [
        { h: "Дашборды внутри вашего продукта", items: ["React", "TypeScript", "Recharts", "TanStack Query", "агрегация на сервере"], proof: "erp", also: ["D3", "виртуализованные таблицы"] },
        { h: "Готовый BI на своём сервере", items: ["Metabase", "Grafana", "Superset"] },
        { h: "Хранение и запросы", items: ["PostgreSQL", "MySQL", "SQLite", "индексы и оптимизация запросов"], proof: "erp", also: ["ClickHouse", "MongoDB", "Redis"] },
        { h: "Аналитика", items: ["Umami", "события на сервере", "данные Search Console"], also: ["Plausible", "Matomo"] },
      ],
      fitsHead: "Кому подходит",
      fits: [
        { h: "Компаниям, которые отчитываются по памяти", p: "Если месячная цифра зависит от того, кто её собрал, это мнение, а не цифра. Сделать её воспроизводимой — обычно неделя работы." },
        { h: "Командам с данными в четырёх местах", p: "Магазин, бухгалтерия, курьер, таблица. Каждый прав насчёт своей части, и никто не сходится в итоге." },
        { h: "Тем, кто не знает, что измерять", p: "Начинаем с решения, а не с графика. Две цифры, по которым вы действуете, лучше сорока, на которые смотрите." },
      ],
    },
    {
      slug: "audit", num: "07", eyebrow: "Технический аудит", kind: "Not sure yet",
      title: "Чтение того, что есть, прежде чем чинить или заменять",
      intro:
        "Переписывание дорого и часто не нужно. Прежде чем решать, полезно знать, что именно не так: код ли проблема, архитектура ли, или всё портит одно неудачное решение. Выводы вы получите независимо от того, наймёте нас потом или нет.",
      includedHead: "Что входит",
      included: [
        { h: "Производительность и Core Web Vitals", p: "Измерено на вашем живом сайте, а не смоделировано. Крупнейшая отрисовка, сдвиг макета, вес страницы, число запросов — и что из этого посетитель действительно замечает." },
        { h: "Технический SEO и индексируемость", p: "Получает ли краулер ваши страницы вообще. Здесь мы чаще всего находим что-то серьёзное: JavaScript-приложение, отдающее пустой документ каждому поисковику." },
        { h: "Архитектура и чтение кода", p: "Где структура станет мешать по мере роста продукта, а где всё в порядке. Включая то, что стоит сохранить, — обычно больше, чем ожидают." },
        { h: "Зависимости и безопасность", p: "Известные уязвимости, заброшенные пакеты, секреты не в тех местах и ошибки конфигурации, которые видны только под нагрузкой или под атакой." },
      ],
      buildsHead: "На что мы смотрим",
      builds: [
        { h: "Скорость на телефонах ваших клиентов", p: "Core Web Vitals, измеренные на живом сайте и на настоящих телефонах, а не на симуляторе с оптикой." },
        { h: "Видят ли вас поисковики", p: "Самая частая серьёзная находка: JavaScript-приложение, отдающее пустой документ каждому краулеру — включая те, что стоят за ответами AI." },
        { h: "Состояние безопасности", p: "Проверки по OWASP, уязвимые и заброшенные зависимости, секреты не в тех местах и конфигурация сервера, которая сдаёт только под атакой." },
        { h: "Нагрузка и точка отказа", p: "Сколько пользователей выдержит, прежде чем ляжет. Это стоит выяснить до кампании, а не во время неё." },
        { h: "Здоровье базы данных", p: "Медленные запросы, отсутствующие индексы и та таблица, которая остановит сайт на четырёхкратном сегодняшнем трафике." },
        { h: "Облачный счёт и мониторинг", p: "За что вы платите и используется ли это, и сообщит ли вам что-нибудь, если оно сломается в три часа ночи." },
        { h: "Архитектура и код", p: "Где структура станет мешать по мере роста продукта и — обычно больше, чем ожидают, — что стоит сохранить." },
      ],
      stackHead: "Чем мы работаем",
      stack: [
        { h: "Производительность", items: ["Lighthouse", "Core Web Vitals", "WebPageTest", "анализ бандла", "Chrome DevTools"], proof: "elegance" },
        { h: "Поиск и индексируемость", items: ["Search Console", "Bing Webmaster Tools", "симуляция обхода", "валидация JSON-LD", "проверка sitemap и hreflang"], proof: "actexpress" },
        { h: "Безопасность", items: ["OWASP Top 10", "аудит зависимостей", "поиск секретов", "TLS и заголовки"] },
        { h: "Нагрузочное тестирование", items: ["k6", "Locust"] },
        { h: "Инфраструктура и наблюдаемость", items: ["планы запросов и индексы", "ревизия nginx и PM2", "Sentry", "аптайм и алерты", "ревизия расходов на облако"], proof: "erp" },
      ],
      fitsHead: "Кому подходит",
      fits: [
        { h: "Перед решением о переписывании", p: "Самый дешёвый час, который вы потратите на этот вопрос. Иногда ответ — что переписывать правильно, и тогда у вас есть доказательства, а не ощущение." },
        { h: "После того как система досталась вам", p: "Новый разработчик, новый CTO, покупка компании. Нужно понять, чем вы теперь владеете, до того как кому-то назовёте срок." },
        { h: "Когда трафик не превращается в клиентов", p: "Иногда маркетинг в порядке, а сайт тихо сломан — медленный на телефонах ваших клиентов или невидимый для поиска." },
      ],
    },
  ],
  industriesPage: {
    eyebrow: "Решения",
    title: "Каждая сфера и каждый город, для которых у нас есть страница",
    intro: "Пятьдесят четыре ситуации, у каждой своя страница: как выглядит работа в этой сфере, сколько она там стоит и в какую услугу в итоге превращается. Начните с той, которая описывает вас, а не со списка технологий.",
    short: "Решения",
    geo: "По месту",
    vertical: "По сфере",
    geoService: "Услуга в городе",
    forService: "Разобранные ситуации",
  },

  niche: {
    eyebrow: "Решения",
    back: "Все решения",
    serviceHead: "Услуга за этим",
    nearHead: "Похожие случаи",
    ctaHead: "Расскажите, что есть и что оно должно делать. Ответим тем, что реально, а не типовым предложением.",
  },

  blog: {
    eyebrow: "Блог",
    title: "Что мы поняли, собирая то, что должно было работать",
    intro: "Инженерные заметки из проектов в продакшене и ответы на вопросы, которые клиенты задают до того, как решиться. Пишем, когда есть о чём, а не по расписанию.",
    listHead: "Все статьи",
    minutes: "мин чтения",
    published: "Опубликовано",
    updated: "Обновлено",
    toc: "На этой странице",
    back: "← Все статьи",
    serviceHead: "К какой услуге относится",
    caseHead: "Откуда это",
    nextHead: "Следующая",
    empty: "Первые статьи пишутся. Загляните позже или задайте вопрос напрямую — так ответ придёт быстрее.",
  },
  tool: {
    eyebrow: "Открытый код",
    title: "crawlview",
    tagline: "Посмотрите, что поисковые системы и AI-краулеры на самом деле сохраняют с ваших страниц — а не то, что показывает браузер.",
    intro: [
      "Браузер выполняет JavaScript, поэтому страница в DevTools — это готовая страница. Большинство краулеров его не выполняют. То, что сохраняют они, может быть пустым контейнером, и на экране об этом ничего не говорит.",
      "crawlview запрашивает страницу по одному разу от имени каждого краулера, сравнивает ответы и показывает, где браузер и машины расходятся. Одна команда, без учётной записи, без установки.",
    ],
    runLbl: "Запуск",
    runHead: "Одна команда",
    runNote: "Нужен Node 20 или новее. Для сравнения с браузером используется уже установленный на машине Chrome — ничего не скачивается втихую.",
    outputLbl: "Как это выглядит",
    outputHead: "Страница, которая отрисовывается в браузере и больше нигде",
    outputNote: "Таблица — это отчёт. Фраза под ней — диагноз, и именно его обход сырого HTML дать не может.",
    checksLbl: "Что проверяет",
    checksHead: "Девять групп проверок",
    checks: [
      { h: "Расхождение", p: "Что сохраняет каждый краулер против того, что отрисовывает браузер: текст, структурированные данные и внутренние ссылки, появляющиеся только после JavaScript — так целый сайт становится ненаходимым с собственной главной страницы." },
      { h: "robots.txt для каждого краулера", p: "Разрешён ли каждому краулеру именно этот URL и какое правило это решило, включая Google-Extended и Applebot-Extended: токены, управляющие AI-ответами, но никогда ничего не запрашивающие — иначе их не увидеть никак." },
      { h: "Директивы индексации", p: "Заголовки X-Robots-Tag, невидимые в исходном коде страницы и старше по приоритету, чем мета-тег. Забытый noindex в заголовке живёт месяцами, потому что туда никто не догадывается посмотреть." },
      { h: "Структурированные данные", p: "Обязательные свойства и утверждения, которых сама страница не делает. Разметка вправе описывать только то, что видит посетитель; цена или телефон, существующие лишь в JSON-LD, — это то, за что выдают ручные санкции." },
      { h: "Заявленный язык против настоящего", p: "Переведённый маршрут, отрисовывающий текст языка по умолчанию, заявляет один язык, а отдаёт другой. Признак — одинаковое количество слов во всех переводах, и сайт выглядит безупречно, пока кто-нибудь его не прочитает." },
      { h: "hreflang", p: "Каждая альтернатива запрашивается и проверяется на обратную ссылку. Набор, в котором один участник не отвечает взаимностью, отбрасывается целиком — остальные переводы тоже теряют свои связи." },
      { h: "Готовность к AI-ответам", p: "Получают ли что-нибудь краулеры, не выполняющие JavaScript, сколько текста переживает извлечение контента, дают ли заголовки пригодные разделы и можно ли страницу процитировать." },
      { h: "По всему сайту", p: "Адреса из sitemap, отдающие 404, редирект, noindex или запрещённые; страницы, канонизирующие в другое место; страницы-сироты без единой ссылки; повторяющиеся заголовки; маршруты, которые втайне одна и та же страница." },
      { h: "Мягкие 404", p: "URL, которого не может существовать, отвечающий 200 — то, что одностраничное приложение делает с каждой опечаткой в ссылке на вас." },
    ],
    ciLbl: "В пайплайне",
    ciHead: "Пусть падает сборка, а не квартал",
    ci: [
      "Регрессию отрисовки обычно находят через недели, в Search Console, когда трафик уже ушёл. Это сбой сборки, который никто не настроил ловить.",
      "crawlview завершается ненулевым кодом, когда краулер видит меньше заданной доли браузерного текста, а снимок, закоммиченный в репозиторий, превращает это в сравнение с последним заведомо рабочим запуском. Опубликованное GitHub Action подключает всё это к pull request.",
    ],
    linksLbl: "Где живёт",
    linksHead: "Исходный код и пакет",
    repo: "Исходники на GitHub",
    npm: "Пакет на npm",
    ctaHead: "Запустили у себя и хотите, чтобы проблем не стало?",
    ctaBtn: "Расскажите, что нашлось",
  },
  about: {
    eyebrow: "Команда, четыре года, двадцать проектов",
    title: "О студии",
    intro: [
      "coresmith.dev — независимая студия инженерии ПО. Дизайн, код, деплой и та часть после, где всё должно продолжать работать, — всё внутри, силами одной команды. Между вами и людьми, которые собирают софт, не стоит менеджер по работе с клиентами, и ничего не отдаётся на субподряд без предупреждения.",
      "Команда намеренно небольшая, а круг задач намеренно узкий. Это реальное ограничение, а не формулировка позиционирования: мы берём меньше проектов одновременно, поэтому дата старта — настоящий предел, а не переговорная позиция.",
      "Студия находится в Кишинёве. Большая часть работы — для компаний из Молдовы и Румынии, остальное распределено ещё по четырём странам.",
    ],
    approachLbl: "Как это устроено",
    approachHead: "Сначала объём, потом цена, потом код",
    approach: [
      "Большинство проектов сворачивают не туда до того, как написана первая строка, — в зазоре между тем, что попросили, и тем, что было нужно. Поэтому первый разговор о том, что должно измениться в вашем бизнесе, а не о том, какой фреймворк взять. Этот разговор бесплатный и обычно занимает один созвон.",
      "Дальше вы получаете фиксированную цену за согласованный объём или помесячную работу, если задача действительно открытая. Прайс-листа нет, потому что цена, названная до объёма, — это догадка в костюме цифры.",
      "Работа сдаётся от начала до конца: дизайн, сборка, деплой, мониторинг. При передаче код лежит в вашем репозитории под вашим аккаунтом, с документацией и runbook, и чтобы поддерживать свой софт живым, вы от нас не зависите.",
    ],
    valuesLbl: "На чём это стоит",
    valuesHead: "Четыре вещи, которыми мы не торгуем",
    values: [
      { h: "Оно должно работать в продакшене", p: "Три из четырёх систем на этом сайте работают в продакшене сегодня. Четвёртая — открытый эксперимент, и на её странице так и написано. Демо, которое впечатляет и никуда не доходит, — не работа, а экспонат портфолио." },
      { h: "Цифры измерены", p: "Каждое число на сайте измерено, а не оценено: время загрузки из настоящего браузера на живых сайтах, вес страниц из сети, число маршрутов из sitemap. Что не можем измерить — не утверждаем." },
      { h: "Вы владеете тем, за что заплатили", p: "Код в вашем репозитории, документация, которую можно передать другому, runbook для скучных частей. Проверка простая: сможет ли другой инженер принять это, не позвонив нам. Если нет — не закончено." },
      { h: "Честный ответ, заранее", p: "Если то, что вы попросили, — не то, что нужно, вы услышите это до, а не через три месяца. Иногда честный ответ в том, что проект вам вообще не нужен." },
    ],
    worksLbl: "Как мы работаем",
    worksHead: "Шесть привычек, которые решают исход",
    works: [
      { h: "Понять задачу до выбора инструмента", p: "Веб-приложение, десктоп, интеграция — это уже ответы. Вопрос, на который они отвечают, надо задать первым, иначе получится хорошо сделанное решение не той проблемы." },
      { h: "Меньше деталей, работающих правильно", p: "Каждая зависимость, каждый сервис и каждый экран — это то, что может сломаться в три часа ночи. Наименьшая система, которая делает работу, обычно и стоит через два года." },
      { h: "Измерять вместо спора", p: "Разногласия о производительности, структуре или приоритете закрываются измерением. Это час работы и конец обсуждению навсегда." },
      { h: "Еженедельное демо, на которое можно нажать", p: "Не отчёты о статусе. Что-то работающее, что можно открыть и попробовать, каждую неделю, чтобы неверное направление стоило недели, а не квартала." },
      { h: "Письменный объём, обычным языком", p: "Что делает, что считается готовым и явно — что не входит. Последний пункт предотвращает больше споров, чем первые два вместе." },
      { h: "Сдача включает следующий день", p: "CI/CD, мониторинг и runbook — часть работы, а не допродажа. Систему, которую никто не может задеплоить или отладить, не сдали, а бросили на месте." },
    ],
    numbersLbl: "Где всё стоит",
    numbersHead: "Цифры, без обиняков",
    numbers: [
      { v: "4", l: "года" },
      { v: "20", l: "проектов" },
      { v: "6", l: "стран" },
    ],
    ctaHead: "Начните с разговора об объёме. Он ничего не стоит и обычно укладывается в один созвон.",
    ctaBtn: "Начать проект",
  },
  caseBack: "← Все работы",
  caseVisit: "Открыть сайт",
  caseCta: "Нужно что-то похожее?",
  caseCtaBtn: "Начать проект",
  caseNext: "Следующий кейс",
  caseCount: (i, total) => `Кейс ${String(i).padStart(2, "0")} / ${String(total).padStart(2, "0")}`,

  cases: [
    {
      scene: "erp",
      slug: "erp",
      index: 1,
      phases: { steps: ["разобрано", "размещено", "собрано", "синхронно"], hint: "прокрутите, чтобы собрать систему" },
      title: "ERP для розницы с несколькими складами + POS",
      meta: [{ b: "Розничные операции" }, { t: "2 месяца" }, { t: "своя команда" }, { b: "сдано" }],
      shotAlt:
        "Рендер POS-станции: монитор с открытым чеком — кабель HDMI, адаптер USB-C, SSD, мышь, хаб и подставка под монитор — с подытогом, НДС, скидкой и итогом 4 673 лея, плюс кнопка оплаты. Рядом карточный терминал и фискальный принтер, соединённые кабелями.",
      blocks: [
        {
          lbl: "Проблема",
          h3: "Три точки, один файл Excel, никакой связи с фискальником.",
          p: [
            "Остатки жили в таблицах Excel, которые вручную копировали между точками. Касса не знала, что лежит на складе, и ничего не общалось с фискальным принтером — каждый чек перебивали заново на отдельном устройстве.",
            "Ошибки в подсчётах накапливались: продажа в одном магазине не видела резерв в другом.",
          ],
        },
        {
          lbl: "Подход",
          h3: "Одна схема, один бинарник, offline с самого начала.",
          p: [
            "Единая схема PostgreSQL как источник истины для остатков, цен и документов; десктопный клиент говорит с ней через тонкий слой Express. Клиент работает в зале и продолжает работать, когда сеть падает.",
            "Фискальный принтер был самой трудной частью: управляется по serial, из того же действия, которое закрывает продажу, — чтобы чек никогда не мог разойтись с записанной транзакцией.",
          ],
        },
        {
          lbl: "Архитектура",
          h3: "Десктопный клиент на настоящей базе данных.",
          p: [
            "Оболочка Electron, React 19 с TypeScript, Zustand для локального состояния и TanStack Query для серверного кеша. За ними Express и Sequelize, PostgreSQL с 43 таблицами: точки, движения, документы, аудит.",
          ],
        },
        { lbl: "Результат", h3: "От продажи до фискального чека одним нажатием.", p: [] },
      ],
      chips: ["Electron", "React 19", "TypeScript", "Zustand", "TanStack Query", "MUI", "Express", "Sequelize", "PostgreSQL", "serialport", "TREMOL S"],
      kpis: [{ v: "43", l: "таблицы" }, { v: "3", l: "точки" }, { v: "2 мес.", l: "до продакшена" }],
      outcome:
        "Остаток снова одно число. Фискальный чек печатается из той же транзакции, которая записывает продажу, поэтому магазин и налоговый учёт больше не могут разойтись.",
    },
    {
      scene: "vision",
      slug: "vision",
      index: 2,
      phases: { steps: ["разобрано", "размещено", "собрано", "закрыто"], hint: "прокрутите, чтобы собрать плату" },
      title: "Продукт компьютерного зрения с AI на устройстве",
      meta: [{ b: "CV в реальном времени", t: " · своё железо" }, { t: "в работе" }, { t: "своя команда" }, { b: "в продакшене" }],
      blocks: [
        {
          lbl: "Проблема",
          h3: "Детекция и OCR быстрее 100 мс — на плате, которой ещё не существовало.",
          p: [
            "Продукту нужны были детекция объектов и распознавание текста прямо на устройстве, достаточно быстро, чтобы это ощущалось мгновенным, и на железе достаточно дешёвом для серийного выпуска. Без похода в облако.",
            "И ещё одно ограничение: один и тот же бинарник C++ должен был работать и на компьютере разработчика, и на embedded-плате, иначе скорость итераций рухнула бы.",
          ],
        },
        {
          lbl: "Подход",
          h3: "Один пайплайн, три движка инференса.",
          p: [
            "Пайплайн зрения написан один раз — против интерфейса инференса с тремя реализациями: ONNX Runtime для десктопа, RKNN для NPU на устройстве, OpenCV DNN как запасной вариант. Смена движка — правка конфига, а не переписывание.",
            "Кадры не покидают память GPU между захватом и инференсом: GStreamer перемещает их zero-copy, и именно там выигралась большая часть бюджета задержки.",
          ],
        },
        {
          lbl: "Архитектура",
          h3: "Софт и плата, на которой он работает.",
          p: [
            "C++17, YOLO для детекции, PP-OCRv4 (DBNet ищет текст, CRNN его читает). Устройство представляется как USB HID, поэтому хосту не нужен драйвер. За ним следит systemd.",
            "Плата тоже наша: 8-слойный PCB вокруг RK3576 с LPDDR4X, разведён в KiCad.",
          ],
        },
        { lbl: "Результат", h3: "30 fps, на устройстве, без облака.", p: [] },
      ],
      chips: ["C++17", "YOLO", "ONNX Runtime", "RKNN", "OpenCV DNN", "PP-OCRv4", "GStreamer", "USB HID", "systemd", "RK3576", "LPDDR4X", "KiCad"],
      kpis: [{ v: "30 fps", l: "пайплайн" }, { v: "3", l: "движка инференса" }],
      outcome:
        "Детекция и OCR работают целиком на плате. Тот же бинарник отлаживается на ноутбуке — поэтому продукт вообще дошёл до выпуска.",
    },
    {
      scene: null,
      site: { host: "neplaceshop.md", url: "https://neplaceshop.md", w: 1440, h: 4246 },
      slug: "commerce",
      index: 3,
      phases: { steps: [], hint: "" },
      title: "Двуязычный интернет-магазин электроники",
      meta: [{ b: "Сайт", t: " · интернет-магазин" }, { t: "2 языка" }, { t: "своя команда" }, { b: "в работе" }],
      shotAlt:
        "Главная neplaceshop.md на румынском: оранжевый баннер «Accesorii auto inteligente» в окружении видеорегистраторов, держателей для телефона и автоаксессуаров, над строкой поиска.",
      blocks: [
        {
          lbl: "Проблема",
          h3: "Два языка, один местный платёжный канал, сотни товаров без описаний.",
          p: [
            "Каталог должен был существовать полностью на румынском и русском, а не как недоведённый перевод. Платежи должны были проходить через MAIB, местный банк, а не через Stripe. И каждому товару нужно было описание, которое никому не хватало времени написать.",
          ],
        },
        {
          lbl: "Подход",
          h3: "Язык как базовое измерение, а не плагин.",
          p: [
            "Контент хранится по языкам на уровне поля, поэтому товар может быть готов на одном языке и в работе на другом, не ломая страницу. Язык есть в маршруте, поэтому обе версии индексируются отдельно.",
            "Описания генерируются один раз из спецификации, потом их правит человек перед публикацией. Сгенерированный текст, который никто не читает, хуже отсутствия текста.",
          ],
        },
        {
          lbl: "Архитектура",
          h3: "Магазин, платежи и уведомления вокруг них.",
          p: [
            "Фронтенд на React, API на Express с PostgreSQL. Шлюз MAIB для оплаты картой, фискальный счёт при завершении заказа. События заказа расходятся в Telegram для магазина и в почту для покупателя.",
            "Страницы пререндерятся, поэтому краулер видит полный HTML, с JSON-LD Schema.org для каждого товара.",
          ],
        },
        { lbl: "Результат", h3: "1 500 посетителей в день, оба языка полностью.", p: [] },
      ],
      chips: ["React", "Express", "PostgreSQL", "MAIB gateway", "фискальный счёт", "OpenAI copy", "Telegram", "Mailgun", "React Snap", "JSON-LD"],
      kpis: [{ v: "1 500", l: "посетителей в день" }, { v: "0,66 с", l: "крупнейшая отрисовка" }, { v: "320", l: "адресов в sitemap" }],
      outcome:
        "Измерено на живом сайте: крупнейший элемент отрисовывается за 0,66 с, а страница товара доходит до краулера с 700 словами собственного текста, а не пустой оболочкой.",
    },
    {
      scene: "trading",
      slug: "trading",
      index: 4,
      phases: { steps: ["разобрано", "размещено", "собрано", "торговля"], hint: "прокрутите, чтобы собрать место" },
      title: "Исследовательский торговый бот на AI",
      meta: [{ b: "R&D", t: " · рынки предсказаний + крипто" }, { t: "в работе" }, { t: "своя команда" }, { b: "на бумаге" }],
      blocks: [
        {
          lbl: "Вопрос",
          h3: "Обыгрывает ли рассуждение индикаторы на длинных удержаниях?",
          p: [
            "Это не продукт. Это эксперимент с вопросом, который можно опровергнуть: на позициях, которые держат днями, а не секундами, принимает ли языковая модель, читающая те же данные, решения лучше, чем движок правил?",
            "Работает на бумаге, на реальных ценах и с жёстким дневным лимитом убытка.",
          ],
        },
        {
          lbl: "Подход",
          h3: "Модель предлагает, движок риска решает размер.",
          p: [
            "Claude читает рыночный контекст и выдаёт тезис с числом уверенности. Движок риска — обычный детерминированный код — превращает уверенность в размер позиции, ограниченный доступным балансом и дневным лимитом убытка. Модель никогда не назначает размер своим ставкам сама.",
            "Каждое решение пишется в журнал вместе с данными, на которых оно принято, поэтому плохую сделку можно проиграть заново и обсудить.",
          ],
        },
        {
          lbl: "Архитектура",
          h3: "Планировщик, биржа, журнал, дашборд.",
          p: [
            "Python 3.12. ccxt для доступа к биржам, pandas-ta для индикаторов, Anthropic Claude Opus для шага рассуждения, SQLAlchemy поверх aiosqlite как журнал, APScheduler крутит цикл, Streamlit для дашборда.",
          ],
        },
        { lbl: "Результат", h3: "Обнадёживает — и всё ещё эксперимент.", p: [] },
      ],
      chips: ["Python 3.12", "Claude Opus", "ccxt", "pandas-ta", "SQLAlchemy", "aiosqlite", "APScheduler", "Streamlit", "движок риска"],
      kpis: [{ v: "~+1,5%", l: "медианный дневной P&L" }, { v: "1 нед.", l: "тест на бумаге" }],
      outcome:
        "Неделя на 100 долларах на бумаге — это сигнал, а не результат. Здесь он и описан как есть: открытый эксперимент с сохранёнными логами.",
    },
    {
      scene: null,
      site: { host: "createli.md", url: "https://createli.md", w: 1440, h: 5219 },
      slug: "createli",
      index: 5,
      phases: { steps: [], hint: "" },
      title: "Createli Group — мебель на заказ",
      meta: [{ b: "Сайт" }, { t: "румынский" }, { t: "своя команда" }, { b: "в работе" }],
      shotAlt:
        "Главная createli.md: кухня на заказ, снятая при дневном свете, заголовок «Mobilier personalizat pentru Toate Nevoile» и две кнопки — мебель из дерева и мебель для школ.",
      blocks: [
        {
          lbl: "Проблема",
          h3: "Одна мастерская, два покупателя без ничего общего.",
          p: [
            "Createli делает мебель из дерева на заказ для дома и оснащает школы и детские сады. Семья, выбирающая кухню, и снабженец, закупающий сорок парт, ищут разные страницы и читают разные слова. Один сайт должен был обслужить обоих, не превратившись в каталог, который не служит никому.",
          ],
        },
        {
          lbl: "Подход",
          h3: "Развилка стоит на первом экране.",
          p: [
            "Первый экран предлагает два направления двумя кнопками, и каждая ведёт на страницу, написанную своим языком: материалы, отделка и монтаж для дома; прочность, размеры и поставка для учреждений.",
            "Товары — это данные, а не страницы. У каждого своя маршрутизация, сгенерированная из API, поэтому новый товар — строка в базе, а не деплой.",
          ],
        },
        {
          lbl: "Архитектура",
          h3: "React спереди, статический HTML на сборке.",
          p: [
            "Vite и React, за ними Express API. Каждый маркетинговый маршрут и каждая страница товара рендерятся headless-браузером во время сборки, поэтому краулер или соцсеть получают полный HTML с мета этой страницы — а не пустую оболочку, которая заполняется только после JavaScript.",
            "Пререндер работает против локального сервера, а не против живого сайта. Так сборка замкнута сама на себя: ни один деплой не зависит от того, что предыдущий ещё жив.",
          ],
        },
        { lbl: "Результат", h3: "Тринадцать маршрутов приходят целыми.", p: [] },
      ],
      chips: ["React", "Vite", "TypeScript", "Tailwind", "shadcn/ui", "Express", "Puppeteer prerender", "react-helmet-async", "PM2", "nginx"],
      kpis: [{ v: "0,000", l: "сдвиг макета" }, { v: "2,3 с", l: "крупнейшая отрисовка" }, { v: "13", l: "маршрутов в пререндере" }],
      outcome:
        "Измерено на живом сайте: ничего не смещается, пока страница грузится, а крупнейший элемент отрисовывается внутри порога «хорошо» у Google.",
    },
    {
      scene: null,
      site: { host: "elegance-transfer.com", url: "https://elegance-transfer.com", w: 1440, h: 7710 },
      slug: "elegance",
      index: 6,
      phases: { steps: [], hint: "" },
      title: "Elegance Transfer — бронирование на четырёх языках",
      meta: [{ b: "Сайт", t: " · трансферный оператор" }, { t: "4 языка" }, { t: "своя команда" }, { b: "в работе" }],
      shotAlt:
        "Главная elegance-transfer.com на русском: тёмный первый экран с седаном ночью, заголовок «Люкс и комфорт в каждой поездке» и кнопка бронирования.",
      blocks: [
        {
          lbl: "Проблема",
          h3: "Шесть коридоров, продаваемых четырём языковым рынкам.",
          p: [
            "Elegance возит по коридору Молдова — Украина — Румыния: аэропорт, междугородние трансферы, перегон автомобилей. Клиенты приходят на русском, румынском, английском и украинском, а тот, кто ищет конкретный маршрут, не получает ответа от главной страницы, которая перечисляет все сразу.",
          ],
        },
        {
          lbl: "Подход",
          h3: "Каждый маршрут — своя страница, на каждом языке.",
          p: [
            "Кишинёв — Одесса, Бухарест, Яссы, Киев, Львов и Черновцы: у каждого своя страница, и каждая существует на всех четырёх языках со своим адресом. Поиск одного коридора приводит на страницу этого коридора.",
            "Форма бронирования пишет в базу и отправляет заявку в Telegram, где диспетчер и так работает. Ни второго инструмента, ни дашборда, который надо осваивать.",
          ],
        },
        {
          lbl: "Архитектура",
          h3: "Четыре локали на уровне поля, Telegram вместо консоли.",
          p: [
            "Vite и React, i18next держит четыре языка поле за полем, поэтому страница может быть готова на одном и в работе на другом, ничего не ломая. За ними Express и MySQL плюс Telegram-бот, принимающий каждую заявку.",
            "После каждого деплоя headless-браузер рендерит все 248 маршрутов в статический HTML, поэтому каждая страница маршрута и каждая машина доходят до краулера со своими мета и JSON-LD, а не пустой оболочкой.",
          ],
        },
        { lbl: "Результат", h3: "248 маршрутов, четыре языка, все индексируются.", p: [] },
      ],
      chips: ["React", "Vite", "TypeScript", "Tailwind", "i18next", "Express", "MySQL", "Telegram Bot API", "Puppeteer prerender", "JSON-LD"],
      kpis: [{ v: "1,3 с", l: "крупнейшая отрисовка" }, { v: "248", l: "маршрутов в пререндере" }, { v: "4", l: "языка" }],
      outcome:
        "Измерено на живом сайте: 1,3 с до крупнейшей отрисовки и сдвиг макета 0,001, причём каждый из четырёх языков индексируется отдельно.",
    },
    {
      scene: null,
      site: { host: "actexpress.md", url: "https://actexpress.md", w: 1440, h: 4841 },
      slug: "actexpress",
      index: 7,
      phases: { steps: [], hint: "" },
      title: "ActExpress — агентство румынских документов",
      meta: [{ b: "Сайт", t: " · агентство документов" }, { t: "2 языка" }, { t: "своя команда" }, { b: "в работе" }],
      shotAlt:
        "Главная actexpress.md на румынском: паспорт и бумаги на столе, заголовок «Partenerul Tău de Încredere pentru Documente Românești» и короткая форма связи рядом.",
      blocks: [
        {
          lbl: "Проблема",
          h3: "Семь процедур, два языка, одна форма.",
          p: [
            "ActExpress занимается румынским гражданством, паспортами, удостоверениями личности, водительскими правами, справками о несудимости, апостилем и присяжными переводами. Семь процедур, у каждой свои бумаги, и клиенты, читающие по-румынски или по-русски. Сайт должен был объяснить все семь достаточно ясно, чтобы человек узнал свой случай, и затем принять заявку с той деталью, которая решает всё дальнейшее: какая именно процедура.",
          ],
        },
        {
          lbl: "Подход",
          h3: "Услуга — это поле, а не фраза.",
          p: [
            "Форма несёт процедуру отдельным полем, поэтому заявка приходит уже разобранной, а не свободным текстом, который сначала надо прочитать и классифицировать.",
            "Оба языка в интерфейсе с первой загрузки: определяются по браузеру и переключаются вручную. Политика конфиденциальности и условия есть на обоих — агентству, которое работает с чужими документами и не может показать собственные условия, верят хуже.",
          ],
        },
        {
          lbl: "Архитектура",
          h3: "Проверка с двух сторон, доставка в два места.",
          p: [
            "React на Vite спереди, Express и MySQL сзади. Форма проверяется в браузере через react-hook-form и ещё раз на сервере через express-validator, потому что проверка в браузере — это удобство, а не гарантия.",
            "Каждая заявка пишется в базу и уходит письмом в офис в том же запросе, а перед эндпоинтом стоит ограничение частоты, чтобы форму нельзя было превратить в почтовый релей.",
          ],
        },
        { lbl: "Результат", h3: "Самый лёгкий из четырёх сайтов здесь.", p: [] },
      ],
      chips: ["React", "Vite", "react-i18next", "react-hook-form", "Tailwind", "Sass", "Express", "MySQL", "Nodemailer", "express-validator"],
      kpis: [{ v: "674 КБ", l: "вес страницы" }, { v: "1,6 с", l: "крупнейшая отрисовка" }, { v: "22", l: "запроса" }],
      outcome:
        "Измерено на живом сайте: 674 КБ за 22 запроса — меньше половины веса остальных трёх, а крупнейший элемент отрисовывается за 1,6 с.",
    },
  ],

  notFound: {
    eyebrow: "Ошибка · 404",
    title: ["Этот маршрут", "не компилируется."],
    text: (p) => `${p} не соответствует ни одному зарегистрированному маршруту.`,
    notes: ["студия на одной странице", "семь проектов и что каждый изменил", "что мы делаем, в семи строках", "цена и сроки, с ответом", "два вопроса и описание"],
  },

  footer: {
    rights: "© 2026 · Независимая инженерная студия",
    reach: "Кишинёв, Молдова — работаем в Молдове и Румынии",
    privacy: "Конфиденциальность",
    terms: "Условия",
  },

  legalOnlyEn: "Этот документ существует только на английском. Английская версия — та, которая имеет силу.",
};
